import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from '../../Context/AuthContext';

const useAdminDeleteProduct = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (productId) =>
      axios.delete(
        `${process.env.REACT_APP_SERVER_URL}/product/products/${productId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('products');
      },
    }
  );

  return {
    deleteProduct: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  };
};

export default useAdminDeleteProduct;
